/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Segment, Tab, Icon, Menu, Button } from 'semantic-ui-react';

import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
  AvRadio,
  AvRadioGroup,
} from 'availity-reactstrap-validation';

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import {
  map,
  get,
  find,
  isEmpty,
  concat,
  uniq,
  flattenDeep,
  sum,
} from '../../../../utils/lodash';

import { CustomTooltip } from '../../../../components';
import { updateEvaluationSelfAssess } from '../../../../store/actions';
import { UserTextService } from '../../../../services';
import { ActivityOutcomeRatings } from '../../../../components/charts/ActivityOutcomeRatings';

import '../activity.scss';

const marks = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
};

const trackStyle = {
  backgroundColor: '#dad3d3c9',
  height: '15px',
  marginTop: '-16px',
};

const handleStyle = {
  height: '50px',
  width: '50px',
  marginTop: '-35px',
  marginLeft:
    import.meta.env.REACT_APP_ENV_VALUE !== 'production' ? '-25px' : '',
  backgroundColor: '#ef8123',
  border: 'none',
};

const activeDotStyle = {
  borderColor: '#dad3d3c9',
  backgroundColor: '#dad3d3c9',
  height: '2rem',
  width: '2rem',
  border: 'none',
  marginLeft: '-0.875rem',
};

const NewEvaluationPlanSection = ({
  evalPlan,
  data,
  evalManage,
  currentActivity,
  isFileChanged,
  evalAssesmentTypes,
  evalReasons,
  assessmentTypes,
  setAssessmentTypes,
  focusPlanId,
  user,
  currentState,
  pageDisabled,
  setActualParticipantsEvaluated,
  ...props
}) => {
  const [participants, setParticipants] = useState(
    evalPlan.actualParticipantsEvaluated
      ? evalPlan.actualParticipantsEvaluated
      : 0
  );
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const handleAssessmentChange = (check, value, id) => {
    let index = assessmentTypes.indexOf(id);
    if (check === true) {
      assessmentTypes.push(id);
    } else {
      if (assessmentTypes.includes(id)) {
        if (index > -1) {
          assessmentTypes.splice(index, 1);
        }
      }
    }
    setAssessmentTypes(uniq(assessmentTypes));

    dispatch(
      updateEvaluationSelfAssess(currentActivity.id, evalPlan.id, {
        assessmentTypes: uniq(assessmentTypes),
        seriesParentId: evalPlan.seriesParentId,
        seriesPosition: evalPlan.seriesPosition,
      })
    );
  };

  const handleParticipants = async (value) => {
    setParticipants(value);
    dispatch(
      updateEvaluationSelfAssess(currentActivity.id, evalPlan.id, {
        actualParticipantsEvaluated: Number(value),
        seriesParentId: evalPlan.seriesParentId,
        seriesPosition: evalPlan.seriesPosition,
      })
    );
  };

  const handleMethodChange = (methodId) => {
    dispatch(
      updateEvaluationSelfAssess(currentActivity.id, evalPlan.id, {
        methodReason: methodId,
        seriesParentId: evalPlan.seriesParentId,
        seriesPosition: evalPlan.seriesPosition,
      })
    );
  };

  return (
    <Fragment>
      <div className="url-card  plan-documentation">
        <div className="obj-div">
          <div className="tabs-evaluation">
            <div className="outcomes-segment">
              <Grid.Row>
                <label className="self-eval-header method">
                  <strong>{t('survey.mgr_assessed_evaluation_method')} </strong>
                </label>
                {props.setEval.question.methodHeading ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: props.setEval.question.methodHeading,
                    }}
                    className="survey-gap"
                  />
                ) : null}
                <div className="eval-method-container">
                  <label
                    className="self-eval-header"
                    id={`${focusPlanId}_methodReason`}
                  >
                    {t('survey.reason_for_evaluation_method')}
                    <span className="required-asterisk">*</span>
                  </label>

                  <Segment
                    disabled={
                      currentActivity.statusId === 3 || pageDisabled
                        ? true
                        : false
                    }
                  >
                    {evalReasons && evalReasons.length > 0 && (
                      <AvRadioGroup
                        id={`${focusPlanId}_methodReason`}
                        name={`${focusPlanId}_methodReason`}
                        className="eval-checkBox"
                        value={evalPlan.methodReason}
                        validate={{
                          required: {
                            value: true,
                            errorMessage: t(
                              'survey.reason_for_evaluation_method_required'
                            ),
                          },
                        }}
                      >
                        <Grid>
                          {map(evalReasons, (reason, i) => (
                            <Grid.Column
                              className="survey-row"
                              key={i}
                              mobile={16}
                              tablet={8}
                              computer={5}
                            >
                              <div className="eval-method-radio">
                                {/* {reason.name} */}
                                <AvRadio
                                  key={reason.id}
                                  type="radio"
                                  label={reason.name}
                                  value={reason.id}
                                  onChange={() => handleMethodChange(reason.id)}
                                />
                              </div>
                            </Grid.Column>
                          ))}
                        </Grid>
                      </AvRadioGroup>
                    )}
                  </Segment>
                </div>
              </Grid.Row>
              <Grid.Row>
                <div className="eval-method-container">
                  <label
                    className="self-eval-header"
                    id={`${focusPlanId}_assessmentTypes`}
                  >
                    {t('survey.assessment_based_on')}
                    <span className="required-asterisk">*</span>
                  </label>
                  <Segment
                    disabled={
                      currentActivity.statusId === 3 || pageDisabled
                        ? true
                        : false
                    }
                  >
                    {evalAssesmentTypes && evalAssesmentTypes.length > 0 && (
                      <AvCheckboxGroup
                        id={`${focusPlanId}_assessmentTypes`}
                        name={`${focusPlanId}_assessmentTypes`}
                        className="eval-checkBox firefox-checkbox-color"
                        validate={{
                          required: {
                            value: assessmentTypes.length > 0 ? false : true,
                            errorMessage: t('survey.assessment_basis_required'),
                          },
                        }}
                      >
                        <Grid>
                          {map(evalAssesmentTypes, (types, index) => (
                            <Grid.Column
                              key={index}
                              mobile={16}
                              tablet={8}
                              computer={16}
                              className="grid-column-assessment"
                            >
                              <div className="eval-method-checkbox">
                                <AvCheckbox
                                  key={`eval-method-checkbox_${index}`}
                                  label={types.name}
                                  value={types.id}
                                  onChange={(e) =>
                                    handleAssessmentChange(
                                      e.target.checked,
                                      e.target.value,
                                      types.id
                                    )
                                  }
                                  checked={
                                    assessmentTypes.includes(types.id)
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Grid.Column>
                          ))}
                        </Grid>
                      </AvCheckboxGroup>
                    )}
                  </Segment>
                </div>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column mobile={16} tablet={8} computer={8}>
                  <div className="disabled-padding">
                    <Segment
                      disabled={currentActivity.statusId === 3 ? true : false}
                    >
                      <div className="number-participants-div">
                        <CustomTooltip
                          className="number-participants-bottom"
                          position="bottom left"
                        >
                          <AvField
                            id={`${focusPlanId}_actualParticipantsEvaluated`}
                            name={`${focusPlanId}_actualParticipantsEvaluated`}
                            label={
                              <>
                                {t('survey.number_of_participants_considered')}
                                <span className="required-asterisk">*</span>
                              </>
                            }
                            className={`number-participants-input ${
                              (get(data, 'collectionMethod') === 'LINK' ||
                                get(data, 'collectionMethod') === 'CSV') &&
                              get(data, 'method.id', 0) !== 9
                                ? 'participants-disabled'
                                : ''
                            }`}
                            disabled={
                              ((get(data, 'collectionMethod') === 'LINK' ||
                                get(data, 'collectionMethod') === 'CSV') &&
                                get(data, 'method.id', 0) !== 9) ||
                              pageDisabled
                                ? true
                                : false
                            }
                            value={participants}
                            type="number"
                            min="1"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t(
                                  'formulary.validation.number_of_participants_considered_required'
                                ),
                              },
                            }}
                            onBlur={(event) => {
                              handleParticipants(event.target.value);
                            }}
                          />
                          {/* <label>
                            Recommended sample size is 102 participants
                          </label> */}
                        </CustomTooltip>
                        {/*  */}
                      </div>
                    </Segment>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const ActivitySurvey = ({
  index,
  question,
  objectiveId,
  evalView,
  allQuestions = false,
  cumulative,
  method,
  currentActivity,
  reason_focusId,

  pageDisabled,
  evalPlan,
  onRatingSaved,
}) => {
  const evaluationQuestion = get(evalPlan, 'evaluationQuestions', []).find(
    (item) => item.objectiveId === objectiveId
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const onRatingChange = async (rating, name) => {
    await dispatch(
      updateEvaluationSelfAssess(currentActivity.id, evalPlan.id, {
        seriesParentId: evalPlan.seriesParentId,
        seriesPosition: evalPlan.seriesPosition,
        results: {
          id: evaluationQuestion.id,
          resultType: name,
          result: rating,
          cumulative,
        },
      })
    );
    onRatingSaved?.();
  };

  const onReasonChange = (reason) => {
    dispatch(
      updateEvaluationSelfAssess(currentActivity.id, evalPlan.id, {
        seriesParentId: evalPlan.seriesParentId,
        seriesPosition: evalPlan.seriesPosition,
        reasonResult: {
          id: evaluationQuestion.id,
          reason,
        },
      })
    );
  };

  const getResultValue = (results, isPre = false) => {
    const result = isPre ? get(results, '[1]', []) : get(results, '[0]', []);
    if (!Array.isArray(result) || result.length === 0) {
      return null;
    }

    const numericResult = result.map((item) => Number(item) || 0);
    const total = sum(numericResult);

    if (total <= 0) {
      return null;
    }

    // Convert the arrays [containing reponse values] into a single rating value
    const weightedTotal = numericResult.reduce(
      (acc, count, idx) => acc + count * (idx + 1),
      0
    );
    return weightedTotal / total;
  };

  const getNumericMean = (value) => {
    const parsed = Number(value);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  };

  // Use pre/post first
  const postRating =
    getNumericMean(get(evaluationQuestion, 'postMean', null)) ??
    getResultValue(get(evaluationQuestion, 'participantResponse', [[], []]));
  const preRating =
    getNumericMean(get(evaluationQuestion, 'preMean', null)) ??
    getResultValue(
      get(evaluationQuestion, 'participantResponse', [[], []]),
      true
    );
  const isPreHigherThanPost =
    Boolean(cumulative) &&
    preRating !== null &&
    postRating !== null &&
    Number(preRating) > Number(postRating);

  if (isEmpty(evaluationQuestion)) return null;

  return (
    <div>
      <div>
        {evalView ? null : (
          <div>
            {question.methodHeading && !index ? (
              objectiveId === 913 || objectiveId === 914 ? (
                <div className="survey-gap">
                  <div>
                    <Trans i18nKey="survey.activity_survey.this_section_description"></Trans>
                    <br></br>
                    <br></br>
                  </div>
                </div>
              ) : objectiveId === 909 || objectiveId === 910 ? (
                <div className="survey-gap">
                  {allQuestions && objectiveId === 910 ? null : (
                    <div>
                      <span>
                        <Trans i18nKey="survey.activity_survey.this_survey_is_based_on_measurable_outcomes_developed_by_cultural_development_network_as_part_of_their_ongoing_research"></Trans>
                      </span>
                      <br></br>
                      <br></br>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: question.methodHeading,
                  }}
                  className="survey-gap"
                />
              )
            ) : null}
            {question.heading ? (
              objectiveId === 913 || objectiveId === 914 ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: question.heading.replace('activity', 'festival'),
                  }}
                  className="survey-gap"
                />
              ) : objectiveId === 909 || objectiveId === 910 ? (
                <div className="survey-gap">
                  {allQuestions && objectiveId === 910 ? null : (
                    <div>
                      <span>
                        <Trans i18nKey="survey.activity_survey.as_an_artist_in_art_not_apart_please_consider_the_following_questions_carefully"></Trans>
                      </span>
                      <br></br>
                      <br></br>
                    </div>
                  )}
                </div>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: question.heading,
                  }}
                  className="survey-gap"
                />
              )
            ) : null}
          </div>
        )}

        {question.question1 ? (
          objectiveId === 913 || objectiveId === 914 ? (
            <div
              dangerouslySetInnerHTML={{
                __html: question.question1.replace('activity', 'festival'),
              }}
              className="survey-gap"
            />
          ) : objectiveId === 909 ? (
            <div className="survey-gap">
              <div>
                <h3>
                  <Trans i18nKey="survey.activity_survey.question_1_knowledge_ideas_or_insight"></Trans>
                </h3>
                <span>
                  <Trans i18nKey="survey.activity_survey.by_knowledge_ideas_or_insight_we_mean"></Trans>
                </span>
                <br />
                <span>
                  <Trans i18nKey="survey.activity_survey.thinking_about_your_participation_what_have_you_gained"></Trans>
                </span>
                <br />
                <br />
              </div>
            </div>
          ) : objectiveId === 910 ? (
            <div className="survey-gap">
              <div>
                <h3>
                  <Trans i18nKey="survey.activity_survey.question_2_agency_and_voice"></Trans>
                </h3>
                <span>
                  <Trans i18nKey="survey.activity_survey.by_agency_and_voice_enabled_we_mean"></Trans>
                </span>
                <br />
                <span>
                  <Trans i18nKey="survey.activity_survey.having_engaged_with_the_festival_how_much_agency_and_voice_do_you_feel_you_have"></Trans>
                </span>
                <br />
                <br />
              </div>
              <hr></hr>
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: question.question1,
              }}
              className="survey-gap"
            />
          )
        ) : get(question, 'question1') ? (
          <div>
            {question.heading ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: question.heading,
                }}
                className="survey-gap"
              />
            ) : null}

            <div
              dangerouslySetInnerHTML={{
                __html: question.question1,
              }}
              className="survey-gap"
            />
          </div>
        ) : null}
        <div>
          <Segment
            disabled={
              currentActivity.statusId === 3 || pageDisabled ? true : false
            }
          >
            {Boolean(cumulative) ? (
              <div className="survey-gap">
                <label>{t('survey.select_response')}</label>
                <>
                  <div className="slider-margin">
                    <Slider
                      min={0.5}
                      defaultValue={evaluationQuestion.postMean}
                      onAfterChange={(rating) =>
                        onRatingChange(rating, 'result1')
                      }
                      marks={marks}
                      max={10.5}
                      step={null}
                      trackStyle={trackStyle}
                      handleStyle={handleStyle}
                      activeDotStyle={activeDotStyle}
                      dotStyle={activeDotStyle}
                      railStyle={trackStyle}
                    />
                  </div>

                  <div className="slider-info-text">
                    <label>{t('common.not_at_all')}</label>
                    <label>{t('common.most_imaginable')}</label>
                  </div>
                </>
                {/* On a scale of 1 to 10 from not at all to most imaginable. */}
                {question.question2 ? (
                  objectiveId === 913 || objectiveId === 914 ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: question.question2.replace(
                          'activity',
                          'festival'
                        ),
                      }}
                      className="survey-gap"
                    />
                  ) : objectiveId === 910 ? (
                    <div className="survey-gap">
                      <div>
                        <span>
                          <Trans i18nKey="survey.activity_survey.thinking_back_to_before_you_engaged_with_the_festival_how_much_agency_and_voice_do_you_feel_you_had"></Trans>
                        </span>
                        <br />
                        <br />
                      </div>
                    </div>
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: question.question2,
                      }}
                      className="survey-gap"
                    />
                  )
                ) : get(question, 'question2') ? (
                  <div>
                    {question.heading ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: question.heading,
                        }}
                        className="survey-gap"
                      />
                    ) : null}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: question.question2,
                      }}
                      className="survey-gap"
                    />
                  </div>
                ) : null}
                <label
                  dangerouslySetInnerHTML={{
                    __html: t('survey.select_before_response'),
                  }}
                />
                <>
                  <div className="slider-margin">
                    <Slider
                      min={0.5}
                      defaultValue={evaluationQuestion.preMean}
                      onAfterChange={(rating) =>
                        onRatingChange(rating, 'result2')
                      }
                      marks={marks}
                      max={10.5}
                      step={null}
                      trackStyle={trackStyle}
                      handleStyle={handleStyle}
                      activeDotStyle={activeDotStyle}
                      dotStyle={activeDotStyle}
                      railStyle={trackStyle}
                    />
                  </div>
                  <div className="slider-info-text">
                    <label>{t('common.not_at_all')}</label>
                    <label>{t('common.most_imaginable')}</label>
                  </div>
                </>
                {isPreHigherThanPost && (
                  <div className="ui negative message rating-warning-message">
                    <Trans
                      i18nKey="survey.higher_rating_warning"
                      components={{ div: <div className="header" /> }}
                    />
                  </div>
                )}
                {/* On a scale of 1 to 10 from not at all to most imaginable. */}
              </div>
            ) : (
              <div className="survey-gap">
                <label>{t('survey.select_response')}</label>
                <>
                  <div className="slider-margin">
                    <Slider
                      min={0.5}
                      defaultValue={evaluationQuestion.postMean}
                      onAfterChange={(rating) =>
                        onRatingChange(rating, 'result1')
                      }
                      marks={marks}
                      max={10.5}
                      step={null}
                      trackStyle={trackStyle}
                      handleStyle={handleStyle}
                      activeDotStyle={activeDotStyle}
                      dotStyle={activeDotStyle}
                      railStyle={trackStyle}
                    />
                  </div>
                  <div className="slider-info-text">
                    <label>{t('common.not_at_all')}</label>
                    <label>{t('common.most_imaginable')}</label>
                  </div>
                </>
                {/* On a scale of 1 to 10 from not at all to most imaginable. */}
              </div>
            )}
          </Segment>
        </div>
        {get(method, 'method', null) === 'Intercept' ? null : (
          <Grid className="custom-gen-questions">
            <Grid.Row>
              <Grid.Column computer={8} mobile={16}>
                <AvField
                  name={`${objectiveId}_Reason`}
                  id={reason_focusId}
                  className="custom-gen-questions-textarea-style"
                  type="textarea"
                  label={
                    <>
                      {Boolean(cumulative)
                        ? t('survey.tell_us_more_two_ratings')
                        : t('survey.tell_us_more_one_rating')}
                      <span className="required-asterisk">*</span>
                    </>
                  }
                  disabled={
                    currentActivity.statusId === 3 || pageDisabled
                      ? true
                      : false
                  }
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t('survey.field_required'),
                    },
                  }}
                  value={evaluationQuestion.selfAssessmentReason}
                  onBlur={(e) => onReasonChange(e.target.value)}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}

        {/* TODO:hardcoded-ids */}
        {objectiveId === 914 ? (
          // || objectiveId === 910
          <div>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={8}>
                  <AvField
                    name={`${objectiveId}_Postcode`}
                    style={{ minHeight: '60px' }}
                    type="text"
                    label={t(
                      'survey.activity_survey.please_tell_us_your_postcode'
                    )}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={8}>
                  <AvField
                    name={`${objectiveId}_Email`}
                    style={{ minHeight: '60px' }}
                    type="email"
                    label={t(
                      'survey.activity_survey.if_you_d_like_to_win_tickets_to_australian_dance_party_political_dance_escape_ferocity_techno_parties_cellar_door_wine_market_and_sound_and_fury_performance_art_party_events_leave_your_email_so_you_can_receive_this_prize'
                    )}
                  />
                </Grid.Column>
              </Grid.Row>
              <div className="survey-gap">
                <Trans i18nKey="survey.activity_survey.this_will_only_be_used_if_you_win_a_prize_thank_you"></Trans>
              </div>
            </Grid>
          </div>
        ) : objectiveId === 910 ? (
          <div>
            <Grid>
              <Grid.Row>
                <Grid.Column computer={8}>
                  <AvField
                    name={`${objectiveId}_Comment`}
                    style={{ minHeight: '100px' }}
                    type="textarea"
                    label={t(
                      'survey.activity_survey.do_you_have_any_other_comments_about_the_festival'
                    )}
                  />
                </Grid.Column>
              </Grid.Row>
              <div className="survey-gap">
                <Trans i18nKey="survey.activity_survey.thats_it_thanks_so_much_festival_photos_are_available_for_download_on_the_next_page"></Trans>
              </div>
            </Grid>
          </div>
        ) : null}
      </div>
    </div>
  );
};

function ActivityEvaluationSurvey({
  evalPlan,
  currentActivity,
  isDisabled,
  checked,
  setChartToReport,
  setToggle,
  ...props
}) {
  const { t } = useTranslation();

  const [one = {}] = get(evalPlan, 'evaluationQuestions', []);
  const objectiveId = get(one, 'objectiveId', null);

  const [objectives, setObjectives] = useState([]);
  const [selectedObjective, setObjective] = useState(objectiveId);
  const [activeIndex, setActiveIndex] = useState(0);

  const [index, setIndex] = useState(0);
  const [assessmentTypes, setAssessmentTypes] = useState(
    evalPlan.assessmentTypes ? evalPlan.assessmentTypes.map((item) => item) : []
  );

  // Allows manager assessed graphs to refresh on slider change (without full page refresh)
  const [chartRefreshToken, setChartRefreshToken] = useState(0);
  const handleRatingSaved = useCallback(
    () => setChartRefreshToken((n) => n + 1),
    []
  );

  // unique focus id for each self assess evaluation plan
  const focusPlanId = evalPlan.id;
  const reason_focusId = `${focusPlanId}_${selectedObjective}_Reason`;

  const evaluationSelfAssessLoading = useSelector(
    (state) => state.activity.evaluationSelfAssessLoading
  );

  useEffect(() => {
    if (selectedObjective) {
      const getObjectives = map(
        get(evalPlan, 'evaluationQuestions', []),
        (obj) => {
          return {
            key: obj.objectiveId,
            text: get(obj, 'outcome.title', '-'),
            value: obj.objectiveId,
          };
        }
      );

      setObjectives(getObjectives);
      includeReportHandler(selectedObjective);
    }
  }, []);

  const evaluationQuestion = find(
    evalPlan.evaluationQuestions,
    (evaluation) => evaluation.objectiveId === selectedObjective
  );

  const evaluation = evaluationQuestion
    ? evaluationQuestion
    : {
        heading: '',
        methodHeading: '',
        question1: '',
        question2: '',
        objectiveId: '',
        outcome: '',
        method: '',
        cumulative: '',
      };

  const isCheckBoxCompleted = useCallback((objective) => {
    const item = evalPlan.evaluationQuestions.find(
      (item) => item.objectiveId === objective.key
    );

    const output =
      evaluationQuestion && item.selfAssessmentReason ? true : false;
    return output;
  });

  const changeObjective = (e, data) => {
    let objectiveId = objectives[data.activeIndex].value;

    setObjective(objectiveId);
    setActiveIndex(data.activeIndex);
    includeReportHandler(objectiveId);
  };

  const setEval = {
    question: {
      heading: evaluation.heading
        ? UserTextService.removeEditableText(evaluation.heading)
        : '',
      methodHeading: evaluation.methodHeading
        ? UserTextService.removeEditableText(evaluation.methodHeading)
        : '',
      question1: evaluation.question1
        ? UserTextService.removeEditableText(evaluation.question1)
        : '',
      question2: evaluation.question2
        ? UserTextService.removeEditableText(evaluation.question2)
        : '',
    },
    objectiveId: evaluation.objectiveId,
    outcome: evaluation.outcome,
    method: evaluation.method,
    cumulative: evaluation.cumulative,
  };

  const { evalReasons, evalAssesmentTypes, pageDisabled } = props;
  const renderTabs = () => {
    const outcomes = map(objectives, (objective, i) => {
      return {
        menuItem: (
          <Menu.Item
            className="activity-goal no-print"
            key={`project.edit.start${i}`}
          >
            <div>
              <span className="customStep-icon">
                {isCheckBoxCompleted(objective) ? (
                  <Icon
                    name="check"
                    className={
                      isCheckBoxCompleted(objective)
                        ? 'outcomes-obj-checked-icon'
                        : 'outcomes-obj-unchecked-icon'
                    }
                    circular
                    size="small"
                  />
                ) : (
                  <Icon
                    name="info"
                    className="outcomes-obj-error-icon"
                    circular
                    size="small"
                  />
                )}
              </span>
              {get(objective, 'text', '-')}
            </div>
          </Menu.Item>
        ),

        render: () => (
          <Tab.Pane
            key={i}
            menu={{ secondary: true, pointing: true }}
            className="outcomes-segment"
          >
            <div className="url-card ">
              {map(evalPlan.evaluationQuestions, (evaluation, i) => {
                if (evaluation.objectiveId === selectedObjective) {
                  setIndex(i);

                  return (
                    <ActivitySurvey
                      key={evaluation.objectiveId}
                      evalPlan={evalPlan}
                      evalView={{ evalReasons, evalAssesmentTypes }}
                      data={find(
                        evalPlan.evaluationQuestions,
                        (evaluation) =>
                          evaluation.objectiveId === selectedObjective
                      )}
                      reason_focusId={reason_focusId}
                      pageDisabled={pageDisabled}
                      currentActivity={currentActivity}
                      {...setEval}
                      {...props}
                      onRatingSaved={handleRatingSaved}
                    />
                  );
                }
              })}
            </div>
          </Tab.Pane>
        ),
      };
    });
    const newArray = concat(outcomes);
    return newArray;
  };

  const scrollToId = (id) => {
    id &&
      document.getElementById(id) &&
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
  };

  const includeReportHandler = (objectiveId) => {
    const currentPlan = get(evalPlan, 'evaluationQuestions', []).find(
      (item) => Number(item.objectiveId) === Number(objectiveId)
    );

    const ignoreAPISave = true;
    setChartToReport(
      get(currentPlan, 'inReport', false),
      objectiveId,
      ignoreAPISave
    );
  };
  const setNextObjective = () => {
    const objectiveId = objectives[1].value;
    setActiveIndex(1);
    setObjective(objectiveId);
    scrollToId(focusPlanId);

    includeReportHandler(objectiveId);
  };

  const setPrevObjective = () => {
    const objectiveId = objectives[0].value;
    setActiveIndex(0);
    setObjective(objectiveId);
    scrollToId(focusPlanId);

    includeReportHandler(objectiveId);
  };

  if (!evaluationQuestion) {
    return null;
  }

  const defaultValues = { assessmentTypes };

  const evaluationQuestions = evalPlan.evaluationQuestions;
  const evaluationQuestion1 = evaluationQuestions[0];
  const evaluationQuestion2 =
    evaluationQuestions.length === 2 ? evaluationQuestions[1] : null;

  const isMetEvaluationQuestion1 =
    get(evaluationQuestion1, 'selfAssessmentReason', null) &&
    sum(flattenDeep(get(evaluationQuestion1, 'participantResponse', []))) !== 0;

  const isMetEvaluationQuestion2 =
    !evaluationQuestion2 ||
    (get(evaluationQuestion2, 'selfAssessmentReason', null) &&
      sum(flattenDeep(get(evaluationQuestion2, 'participantResponse', []))) !==
        0);

  return (
    <div className="form-background">
      <AvForm
        model={defaultValues}
        id={`form_${evalPlan.id}`}
        name={`form_${evalPlan.id}`}
      >
        <div id={`newEvaluationPlanSection_${focusPlanId}`}>
          <NewEvaluationPlanSection
            currentActivity={currentActivity}
            focusPlanId={focusPlanId}
            setEval={setEval}
            assessmentTypes={assessmentTypes}
            setAssessmentTypes={setAssessmentTypes}
            isDisabled={isDisabled}
            evalPlan={evalPlan}
            {...props}
          />
        </div>
        <Tab
          id={`${focusPlanId}`}
          activeIndex={activeIndex}
          className="tabs-graph"
          menu={{ secondary: true, pointing: true }}
          panes={renderTabs()}
          onTabChange={(e, data) => changeObjective(e, data)}
        />

        {index === 0 ? (
          evalPlan.evaluationQuestions.length > 1 ? (
            <Button
              type="button"
              className="ui customColor-custom button outcome-btn"
              onClick={() => {
                setNextObjective();
              }}
            >
              {t('actions.next')}
            </Button>
          ) : null
        ) : (
          <Button
            type="button"
            className="ui customColor-custom button outcome-btn"
            onClick={() => {
              setPrevObjective();
            }}
          >
            {t('actions.back')}
          </Button>
        )}
      </AvForm>
      <Segment
        disabled={currentActivity.statusId === 3 ? true : false}
        loading={evaluationSelfAssessLoading}
      >
        {evalPlan.actualParticipantsEvaluated &&
        isMetEvaluationQuestion1 &&
        isMetEvaluationQuestion2 ? (
          <>
            <div className="eval-plan-objectiveChartToggle eval-plan-objectiveChartToggle--self-assessed">
              <div className="checkbox-container-include-in-report">
                <div className="include-in-report-label">
                  {t('report.include_in_report')}
                </div>
                <div className="button-include">
                  <Button.Group
                    onClick={() =>
                      !isDisabled &&
                      setChartToReport(!checked, selectedObjective)
                    }
                  >
                    <Button active={checked} disabled={isDisabled}>
                      {t('actions.yes')}
                    </Button>
                    <Button active={!checked} disabled={isDisabled}>
                      {t('actions.no')}
                    </Button>
                  </Button.Group>
                </div>
              </div>
            </div>

            <ActivityOutcomeRatings
              activityId={currentActivity.id}
              outcomeId={evaluationQuestion?.outcomeId}
              evaluationPlanIds={[evalPlan.id]}
              showIncludeToggle={false}
              visibleModes={['trend']}
              refreshToken={chartRefreshToken}
            />
          </>
        ) : null}
      </Segment>
    </div>
  );
}

export default ActivityEvaluationSurvey;
